import { getCustomerPositionAsync } from "./helperServices";
import getStoreLists from "./getStoreList";

export const getNearestStore = (storeAddress) => {
	let nearestStore;
	nearestStore = storeAddress.sort((a, b) => {
		if (a.distance < b.distance) { return -1; }
		if (a.distance > b.distance) { return 1; }
		return 0;
	});
	try {
		nearestStore = nearestStore.filter(store => store.inStock)[0];
	} catch (error) {
		nearestStore = nearestStore[0];
	}

	return nearestStore;
}

export default (propsData, sku, populateStoreList, serviceDown) => {
	const dropGeolocation = () => {
		propsData?.setGeoLocationStatus(false);
		propsData?.setGeoLocationPosition({latitude:null, longitude:null});
	}

	const fetchUserLocation = () => {
		getCustomerPositionAsync().then(resultData => {
			const latitude = resultData.result?.latitude;
			const longitude = resultData.result?.longitude;
			if (latitude && longitude) {
				propsData?.setGeoLocationStatus(true);
				propsData?.setGeoLocationPosition({latitude, longitude});
				const location = {
					latitude,
					longitude
				}
				getStoreLists(location, sku, populateStoreList, serviceDown);
			} else {
				dropGeolocation();
			}
		}, _resultDataFailure => {
			dropGeolocation();
			serviceDown(false);
		});
	}

	if (propsData?.geoLocation) {
		const userLocation = propsData?.geoLocation;
		if (userLocation?.allowed && 
			userLocation?.latitude &&
			userLocation?.longitude) {
			getStoreLists(propsData.geoLocation, sku, populateStoreList, serviceDown);
		} else {
			fetchUserLocation();
		}
	} else {
		fetchUserLocation();
	}
}